import { createAsyncThunk, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CurrencyStateKeys, LocalStorageKeys } from "@evr/constant";
import { GetCurrencies } from "@evr/services/sso";
import { RootState } from "@evr/store";
import { CurrencyState } from "@evr/types";
import { localStorageHelper } from "@evr/utils";

const initialState: CurrencyState = {
  [CurrencyStateKeys.CURRENCIES]: [],
  [CurrencyStateKeys.LOADING]: false,
  [CurrencyStateKeys.LOADED]: false,
};

export const initializeCurrencies = createAsyncThunk("currency/initialize", async (_, thunkAPI) => {
  const raw = localStorageHelper.getItem(LocalStorageKeys.CURRENCIES);
  if (raw) {
    return JSON.parse(raw);
  } else {
    const res = await GetCurrencies();
    localStorageHelper.storeItem(LocalStorageKeys.CURRENCIES, JSON.stringify(res.data));
    return res.data;
  }
});

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(initializeCurrencies.pending, state => {
        state[CurrencyStateKeys.LOADING] = true;
      })
      .addCase(initializeCurrencies.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.currencies = action.payload;
        state[CurrencyStateKeys.LOADED] = true;
        state[CurrencyStateKeys.LOADING] = false;
      })
      .addCase(initializeCurrencies.rejected, state => {
        state[CurrencyStateKeys.LOADING] = false;
        state[CurrencyStateKeys.LOADED] = false;
      });
  },
});

export const selectCurrencies = createSelector(
  (state: RootState) => state.currencies,
  currenciesState => currenciesState.currencies,
);

export default currencySlice.reducer;
